import React, { useState } from "react";
import { Button } from "@material-ui/core";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import apiform from "utils/APIForm";
import { makeStyles } from "@material-ui/core/styles";


export default function ModalAceptRequest(props) {
  const { open, closeModal, divisionRequest, moduleType } = props;

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const [scroll, setScroll] = useState("paper");

  function updateDivision() {

    const formData = new FormData();

    formData.append("cantidad_fraccionar", divisionRequest.cantidad_fraccionar);
    formData.append("observaciones", divisionRequest.observaciones);
    formData.append("cantidad_resultante", props.cantidad_resultante);
    formData.append("estado", "Esperar a egresos");
    formData.append(
      "id_producto_fraccionar",
      divisionRequest.id_producto_fraccionar.id
    );
    formData.append("id_producto_resultante", props.id_producto_resultante);
    formData.append("area", "Egresos");

    apiform
      .put(`api/solicitudfraccionamiento/${divisionRequest.id}`, formData)
      .then(response => {
        window.location.href = `/admin/income/divisions/${moduleType}`;
      })
      .catch(error => {});
  }


  return (
    <Dialog
      open={open}
      onClose={closeModal}
      scroll={scroll}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      maxWidth="sm"
      fullWidth={true}
      disableBackdropClick
    >
      <DialogTitle id="scroll-dialog-title">Detalle del pedido</DialogTitle>
      <DialogContent dividers={scroll === "paper"}>
        <div style={{ marginBottom: "10rem" }}>
          <p className="text-center font-weight-bold">
            ¿Está seguro que desea aceptar el fraccionamiento?
          </p>
          <p className="text-center">
            Se notificará a egresos para que realice el descuento respectivo.
          </p>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={updateDivision} color="primary">
          Si
        </Button>
        <Button onClick={closeModal} color="primary">
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ModalAceptRequest.propTypes = {
  open: PropTypes.bool,
  closeModal: PropTypes.func,
  divisionRequest: PropTypes.array,
  cantidad_resultante: PropTypes.number,
  id_producto_resultante: PropTypes.number
};
